import { datatypes, inputTypes } from "data/globalData";
import {
	blueShade2,
	blueShade3,
	defRenderCellWithSX,
	defRenderHeaderWithSX,
	displayInCrRenderCell,
	StandardRenderCellWithChildren,
	tableBorderStyle,
} from "../../data";
import { convertValueInCr, roundDecimalValueUptoTwo } from "utils/roundDecimalValue";
import { grey } from "@mui/material/colors";
import { calculateProjectionDisPercentByMrpRev, calculateProjectionGpWithCm } from "utils/calcultateAOPDataColumns";
import { round } from "lodash";

const renderCellStyle = {
	boxSizing: "border-box",
	borderBottom: tableBorderStyle,
	borderRight: tableBorderStyle,
};

export const projectionTableColumns = {
	PROJ_NSV: {
		name: "NSV",
		key: "PROJ_NSV",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.NUMBER.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		renderHeader: defRenderHeaderWithSX({
			background: blueShade2,
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
		}),
		headerSx: { background: grey[300] },

		valueGetter: function (row, rawData = false) {
			if (rawData) return row["PROJ_NSV"];
			return convertValueInCr(row["PROJ_NSV"]);
		},
		renderCell: function ({ row, field }) {
			let val = this.valueGetter(row);
			return (
				<StandardRenderCellWithChildren
					field={field}
					row={row}
					sx={{
						...renderCellStyle,
						background: blueShade3,
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}}>
					{val}
				</StandardRenderCellWithChildren>
			);
		},
		headerClassName: "blue-header",
		unit: "INR CR.",
		editable: true,
	},
	PROJ_DIS: {
		name: "DIS",
		key: "PROJ_DIS",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.NUMBER.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		renderHeader: defRenderHeaderWithSX({
			background: blueShade2,
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
		}),
		headerSx: { background: grey[300] },

		valueGetter: function (row, rawData = false) {
			if (rawData) return calculateProjectionDisPercentByMrpRev(row);
			return roundDecimalValueUptoTwo(calculateProjectionDisPercentByMrpRev(row));
		},
		renderCell: function ({ row, field }) {
			let val = this.valueGetter(row);

			return (
				<StandardRenderCellWithChildren
					field={field}
					row={row}
					sx={{
						...renderCellStyle,
						background: blueShade3,
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}}>
					{val}
				</StandardRenderCellWithChildren>
			);
		},
		headerClassName: "blue-header",
		unit: "%",
		editable: true,
	},
	proj_gp_with_ch_margin: {
		name: "Gp With Ch Margin",
		key: "proj_gp_with_ch_margin",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		renderHeader: defRenderHeaderWithSX({
			// background: blueShade2,
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
		}),
		headerSx: { background: grey[300] },

		valueGetter: function (row, rawData = false) {
			if (rawData) return calculateProjectionGpWithCm(row);
			return convertValueInCr(calculateProjectionGpWithCm(row));
		},
		renderCell: function ({ row, field }) {
			let val = this.valueGetter(row);

			return (
				<StandardRenderCellWithChildren
					field={field}
					row={row}
					sx={{
						...renderCellStyle,
						// background: blueShade3,
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}}>
					{val}
				</StandardRenderCellWithChildren>
			);
		},
		headerClassName: "default-header",
		unit: "INR CR.",
	},
};
